
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import {
mapState,
} from 'vuex';
import HeaderBase from '../components/header/base.vue'
import contactWay from '../components/contact-way/'

import pageTab from '../components/page-tab/index.vue'
import getMsgMx from '@/common/mixin/getMsg.js'
import refreshLoginMX from '@/common/mixin/refreshLogin/'

export default {
name: 'App',
components: { pageTab, Loading, Alert, HeaderBase, contactWay },
provide() {
return {
QQlink: 'http://wpa.qq.com/msgrd?v=3&uin=261611622&site=baidu.com&menu=yes',
parentCom: this
}
},
inject: ['parentRoot'],
mixins: [refreshLoginMX, getMsgMx],
data() {
return {
noContactPath: ['/promotions'],
include: ['promotions-page'],
showAppDialogName: ['home','menu','Classic','chess','live','sports','Slot','fish','lottery', 'bingo'],  //需要展示顶部下载的name
drawerVisibility: false, //控制侧边栏
slideStyle: {},
isAppOpen: false,
arrRoute: ['/', '/gamelobby/sports', '/gamelobby/egame', '/gamelobby/live', '/gamelobby/chess', '/gamelobby/fish', '/gamelobby/lottery', '/gamelobby/bingo', '/gamelobby/Classic']
};
},
computed: {
...mapState({
isLoading: state => state.vux.isLoading,
UUID: state => state.UUID,
isLogin: state => state.isLogin,
isApp: state => state.isApp, //是否在app打开
isHideAppDialog: state => state.isHideAppDialog, //是否隐藏app导航栏
}),
},
created() {
this.$store.dispatch('checkLogin')
this.$store.dispatch('refreshUserInfo') 
this.$store.dispatch('initSystemInfo') 
this.$store.dispatch('connactLists') 
this._getMsgLists() 
},
mounted() {
window['login'] = (UUID) => {
this.$store.commit('LOGIN', UUID)
this.$Cookies.set('UUID', UUID)
window.localStorage.setItem('UUID', UUID);
let timer = setTimeout(() => {
this.$store.dispatch('checkLogin', UUID)
this.$store.dispatch('refreshUserInfo') 
this._getMsgLists() 
clearTimeout(timer)
},1000)
}
},
methods: {
handleLogout(path) { // 退出登录
this.$store.dispatch('Logout').then(() => {
actionLogEvent("af_logout")  
this.$showToast({ text: this.$t('mine').accountManage.loiginOut, type: 'success' });
this.$router.replace({ path: !path ? '/' : path })
}).catch((msg) => {
this.$showToast({ text: msg, type: 'cancel'});
})
},

goLogin() { // 去登录
this.$router.push({ path: '/login' })
},

goRegister() { // 去注册
this.$router.push({ path: '/signup' })
},








}
};



// WEBPACK FOOTER //
// ./src/pages/build922/views/main/index.vue